export default {
      id: "arrow-right-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }